import request from '../../axios/axiosconfig.js'

export function bcCapitalDetail(params) {
  return request({
    url: '/ps/customerCapitalDetail/getAllCustomerCapitalDetail',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/accountFunds/usfundsdetail.js